import Icon from "@ant-design/icons";
import BuildingSvg from "./building.svg";
import React from "react";
import { IconComponentProps } from "@ant-design/icons/lib/components/Icon";

export const BuildingIcon = (props: IconComponentProps) => <Icon component={BuildingSvg} {...props} />;
